import { useLocation, useNavigate } from "react-router-dom";
import { showSuccessToast } from '../../common/toasts/utils';
import { postLunchMenu } from "../../../utils/api/lunches";
import LunchCreator from "../../common/lunchCreator/LunchCreator";

const CreateLunchPage = () => {
    const {state: template} = useLocation();
    const navigate = useNavigate();

    const handleSubmitSuccess = () => {
        showSuccessToast(['Success! New order has successfully created!']);
        navigate("/latest-lunch");
    }

    const handleSubmit = (lunch) => postLunchMenu(lunch, handleSubmitSuccess);

    const initialStep = template ? 1 : 0;
    return (
        <LunchCreator
            onSubmit={handleSubmit}
            submitLabel="Create"
            template={template}
            initialStep={initialStep}
        />
    );
}

export default CreateLunchPage;
